function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 53 47",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon-warning") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Desktop"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M52.53,41.77l-23-40a3.47,3.47,0,0,0-6,0l-23,40a3.49,3.49,0,0,0,3,5.23H49.53A3.49,3.49,0,0,0,52.53,41.77ZM26.5,14A2.57,2.57,0,0,1,29,16.7l-.41,15.16a2.1,2.1,0,1,1-4.19,0L24,16.7A2.58,2.58,0,0,1,26.5,14Zm0,27A2.5,2.5,0,1,1,29,38.5,2.5,2.5,0,0,1,26.5,41Z",
    transform: "translate(0)",
    style: {
      fill: "#ffb81c"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWarning);
export default __webpack_public_path__ + "static/media/icon-warning.8f7465718f1b1beb9ee88edec339f366.svg";
export { ForwardRef as ReactComponent };